import script from "./googleKeys.vue?vue&type=script&setup=true&lang=js"
export * from "./googleKeys.vue?vue&type=script&setup=true&lang=js"

import "./googleKeys.vue?vue&type=style&index=0&id=63a58e04&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63a58e04"]])

export default __exports__